import React from 'react'

import StoreSelector from '~/components/store-selector'
import { DefaultLayout } from '~/layouts'
import theme from '~/truck/theme'

import Header from './header'

const StoresScreen = () => {
  return (
    <DefaultLayout>
      <Header
        title="Tiendas"
        subTitle="Encuentra la tienda de tu preferencia"
        style={{ marginBottom: theme.spacing.comfortable }}
      />
      <StoreSelector onlyPickables={false} />
    </DefaultLayout>
  )
}

export default StoresScreen
